import React from "react";
import { Box, Typography } from "@mui/material";
import SubaccountManager from "../components/SubaccountManager";

const SubaccountManagementPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ marginBottom: 2 }}>
        Subaccount Management
      </Typography>
      <SubaccountManager />
    </Box>
  );
};

export default SubaccountManagementPage;
